import Vue from "vue";

import TokenTimeout from "./TokenTimeout.vue";

export function load() {
    const selector = "token-timeout";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(TokenTimeout, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
